import Cookies from 'js-cookie'

const lastTime = stamp => {

    let month = new Date().getMonth()
    let year = new Date().getFullYear()
    if (Cookies.get('userType') == 2) {
        month = month + 1;
    }
    // let time = new Date(stamp.replace(/-/g,"/"))
    // let data = time.getDate(),
    //   month = time.getMonth()+1

    // if (data >= 8) {
    //   time.setMonth(month - 1)
    //   return time.getFullYear() + '-' + zero(month)
    // }
    // time.setMonth(month - 2)
    return year + '-' + zero(month)
}
const zero = num => (num * 1 < 10 ? '0' + num : '' + num)

// 时间格式：
const format = function (date, fmt) {
    let da = new Date(date);
    var o = {
        "M+": da.getMonth() + 1, //月份
        "d+": da.getDate(), //日
        "h+": da.getHours(), //小时
        "m+": da.getMinutes(), //分
        "s+": da.getSeconds(), //秒
        "q+": Math.floor((da.getMonth() + 3) / 3), //季度
        S: da.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(
            RegExp.$1,
            (da.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1
                    ? o[k]
                    : ("00" + o[k]).substr(("" + o[k]).length)
            );
    return fmt;
};
const reachStatusOptions = [
    {
        label: '不限',
        value: ''
    },
    {
        label: '未触达',
        value: '0'
    }, {
        label: '已触达',
        value: '1'
    },
]
const companyCardStatusOption = [
    {
        label: '不限',
        value: ''
    },
    {
        label: '联名卡在用客户',
        value: '1'
    }, {
        label: '潜在新客户[0~10%)',
        value: '6'
    }, {
        label: '摇摆客户[10%~20%)',
        value: '5'
    }, {
        label: '低忠诚客户[20%~30%)',
        value: '4'
    }, {
        label: '中忠诚客户[30%~50%)',
        value: '3'
    }, {
        label: '高忠诚客户[50%~100%]',
        value: '2'
    },
]
const devStatusOption = [
    {
        label: '不限',
        value: ''
    },
    {
        label: '终止开发',
        value: '0'
    },
    {
        label: '已开发',
        value: '1'
    }, {
        label: '开发中',
        value: '2'
    }, {
        label: '未开发',
        value: '3'
    }
]
const devStatusOption310 = [
    {
        label: '不限',
        value: ''
    },
    {
        label: '终止开发',
        value: '0'
    },
    {
        label: '已开发',
        value: '1'
    }, {
        label: '开发中',
        value: '2'
    }
]
const devStatusOption310New = [
    {
        label: '终止开发',
        value: '0'
    }
]
const devLogOption = [
    {
        label: '不限',
        value: ''
    },
    {
        label: '有记录',
        value: '1'
    },
    {
        label: '无记录',
        value: '0'
    }
]
const dunWeiOption = [
    {
        label: '全部',
        value: ''
    },
    {
        label: '10吨以下',
        value: '1'
    },
    {
        label: '10(含)-25吨',
        value: '2'
    },
    {
        label: '25(含)-35吨',
        value: '3'
    },
    {
        label: '35吨及以上',
        value: '4'
    }
]
const zhanDianOption = [
    {
        label: '全部',
        value: ''
    },
    {
        label: '加油站',
        value: '1'
    },
    {
        label: '加气站',
        value: '2'
    },
    {
        label: '加氢站',
        value: '3'
    },
    {
        label: '加油加气站',
        value: '4'
    }
]
const zhanDianBrandOption = [
    {
        label: '全部',
        value: ''
    },
    {
        label: 'S级',
        value: 'S'
    },
    {
        label: 'C级',
        value: 'C'
    },
    {
        label: 'E级',
        value: 'E'
    }
]
const zhanDianBrandOptionT = [
    {
        label: '全部',
        value: ''
    },
    {
        label: 'S级',
        value: 'S'
    },
    {
        label: 'C级',
        value: 'C'
    },
    {
        label: 'O级',
        value: 'O'
    },
    {
        label: 'E级',
        value: 'E'
    }
]
const daoLuFenLei = [
    {
        label: '全部',
        value: ''
    },
    {
        label: '首都放射线',
        value: '1'
    },
    {
        label: '北南纵线',
        value: '2'
    },
    {
        label: '东西横线',
        value: '3'
    },
    {
        label: '地区环线',
        value: '4'
    },
    {
        label: '都市圈环线',
        value: '5'
    }
]
const daoLuFenLeiGd = [
    {
        label: '全部',
        value: ''
    },
    {
        label: '首都放射线',
        value: '1'
    },
    {
        label: '北南纵线',
        value: '2'
    },
    {
        label: '东西横线',
        value: '3'
    },
]
const ranLiaoOption = [
    {
        label: '全部',
        value: ''
    },
    {
        label: '柴油',
        value: '1'
    },
    {
        label: 'LNG',
        value: '2'
    },
    {
        label: '电',
        value: '3'
    },
    {
        label: '氢',
        value: '4'
    },
    {
        label: '其他',
        value: '5'
    }
]
const gridData = [
    {
        date: '0-10吨',
        name: '20.8',
    },
    {
        date: '10-20吨',
        name: '23.4',
    },
    {
        date: '20-25吨',
        name: '26.5',
    },
    {
        date: '25-30吨',
        name: '30',
    },
    {
        date: '30-35吨',
        name: '31.7',
    },
    {
        date: '35-40吨',
        name: '36.8',
    },
    {
        date: '40吨以上',
        name: '37.4',
    },
]
const cardTypeOption = [
    {
        label: '不限',
        value: ''
    },
    {
        label: '联名卡',
        value: '1'
    }, {
        label: '普通卡',
        value: '2'
    }, {
        label: '无',
        value: '3'
    }
]
const failedKindOption = [
    {
        label: '信息有误',
        value: '1'
    },
    {
        label: '优惠相关',
        value: '2'
    },
    {
        label: '自行采购',
        value: '3'
    },
    {
        label: '其他',
        value: '4'
    }
]

const failedTypeOption = [
    {
        label: '联系方式有误',
        value: '1'
    }, {
        label: '客户不存在',
        value: '2'
    }, {
        label: '与实际不符',
        value: '3'
    },
    {
        label: '优惠力度客户不认可',
        value: '21'
    }, {
        label: '竞争对手优惠力度更大',
        value: '22'
    }, {
        label: '对方要求过高无法满足',
        value: '23'
    },
    {
        label: '客户有自建罐',
        value: '31'
    }, {
        label: '客户自有油站',
        value: '32'
    }, {
        label: '近期停运',
        value: '41'
    }, {
        label: '其他',
        value: '42'
    }
]
const vehicleCountMaskOption = [
    {
        label: '不限',
        value: ''
    },
    {
        label: '100辆及以上',
        value: 'A'
    }, {
        label: '50-99辆',
        value: 'B'
    }, {
        label: '20-49辆',
        value: 'C'
    }, {
        label: '10-19辆',
        value: 'D'
    }, {
        label: '少于10辆',
        value: 'E'
    }
]
const mileageMaskOption = [
    {
        label: '不限',
        value: ''
    },
    {
        label: '500万(含)公里以上',
        value: '1'
    }, {
        label: '100万(含)-500万公里',
        value: '2'
    }, {
        label: '50万(含)-100万公里',
        value: '3'
    }, {
        label: '10万(含)-50万公里',
        value: '4'
    }, {
        label: '10万公里以下',
        value: '5'
    }
]
const discountTypeOption = [
    {
        label: '明折明扣',
        value: '1'
    }, {
        label: '充值优惠',
        value: '2'
    }, {
        label: '加油优惠-积分',
        value: '3'
    },
    {
        label: '加油优惠-油非互动',
        value: '4'
    },
]
const companyLabelOption = [
    {
        label: '新增客户',
        value: '1'
    }, {
        label: '流失回流客户',
        value: '2'
    }, {
        label: '直分销客户',
        value: '3'
    },
    {
        label: '其他',
        value: '50'
    },
]
const companyLabelOptionShow = [
    {
        label: '新增客户',
        value: '1'
    }, {
        label: '流失回流客户',
        value: '2'
    }, {
        label: '直分销客户',
        value: '3'
    },
    {
        label: '其他',
        value: '50'
    },
    {
        label: '-',
        value: '55'
    },
]
const failedTypeOptionT=[
    {
        value: 'xinxiyouhu',
        label: '信息有误',
        children: [{
            value: '1',
            label: '联系方式有误',
        }, {
            value: '2',
            label: '客户不存在',
        }, {
            value: '3',
            label: '与实际不符',
        }]
    }, {
        value: 'youhuixiangguan',
        label: '优惠相关',
        children: [{
            value: '21',
            label: '优惠力度客户不认可',
        }, {
            value: '22',
            label: '竞争对手优惠力度更大',
        }, {
            value: '23',
            label: '对方要求过高无法满足',
        }]
    }, {
        value: 'zixingcaigou',
        label: '自行采购',
        children: [{
            value: '31',
            label: '客户有自建罐'
        }, {
            value: '32',
            label: '客户自有油站'
        }]
    }, {
        value: 'qita',
        label: '其他',
        children: [{
            value: '41',
            label: '近期停运'
        }, {
            value: '42',
            label: '其他'
        }]
    }
]
const stationType = [
    {
        label: '加油站',
        value: '1'
    }, {
        label: '加气站',
        value: '2'
    }, {
        label: '加氢站',
        value: '3'
    }, {
        label: '加油加气站',
        value: '4'
    }
]
const oilConsumptionRangeOption = [
    {
        label: '不限',
        value: ''
    },
    {
        label: '1-20吨',
        value: '1'
    },
    {
        label: '20-60吨',
        value: '2'
    },
    {
        label: '60-200吨',
        value: '3'
    },
    {
        label: '200-2000吨',
        value: '4'
    },
    {
        label: '2000吨以上',
        value: '5'
    }
]
const companyCardStatusOptionNew = [
    {
        label: '联名卡在用客户',
        value: '1'
    },
    {
        label: '潜在新客户[0~10%)',
        value: '6'
    },
    {
        label: '摇摆客户[10~20%)',
        value: '5'
    },
    {
        label: '低忠诚客户[20~30%)',
        value: '4'
    },
    {
        label: '中忠诚客户[30~50%)',
        value: '3'
    }
]
const petrochemicalStopRadioOption = [
    {
        label: '0-10%',
        value: '0-10'
    },
    {
        label: '10-20%',
        value: '10-20'
    },
    {
        label: '20-30%',
        value: '20-30'
    },
    {
        label: '30-40%',
        value: '30-40'
    },
    {
        label: '40-50%',
        value: '40-50'
    },
    {
        label: '50-60%',
        value: '50-60'
    }
]
const isMoreThanSevenDaysAgo = (timestamp) => {
    const oneDay = 24 * 60 * 60 * 1000; // 一天的毫秒数
    const now = Date.now(); // 当前时间的时间戳
    const target = new Date(timestamp * 1); // 目标时间戳转换为Date对象
    target.setHours('00')
    target.setMinutes('00')
    target.setSeconds('00')
    const targetTime = target.getTime(); // 目标时间的时间戳

    return (now - targetTime) > 7 * oneDay; // 当前时间减去目标时间，判断结果是否大于7天
}
const keyValueCardNum = {
    11: 10001111000,
    31: 10001131000,
    33: 10001133000,
    37: 10001137000,
    42: 10001142000,
    90: 10001190000,
    14: 10001114000,
    36: 10001136000,
    45: 10001145000,
    52: 10001152000,
    51: 10001151000,
    12: 10001112000,
    32: 10001132000,
    35: 10001135000,
    41: 10001141000,
    44: 10001144000,
    13: 10001113000,
    34: 10001134000,
    43: 10001143000,
    46: 10001146000,
    53: 10001153000,
    50: 10001150000,
    21: 10001186210,
    22: 10001186220,
    23: 10001186230,
    61: 10001186610,
    62: 10001186620,
    54: 10001186540,
    15: 10001186150,
    63: 10001186630,
    64: 10001186640,
    65: 10001186650,
}
export default {
    lastTime: lastTime,
    format: format,
    reachStatusOptions,
    companyCardStatusOption,
    companyCardStatusOptionNew,
    devStatusOption,
    devStatusOption310,
    devStatusOption310New,
    devLogOption,
    dunWeiOption,
    zhanDianOption,
    zhanDianBrandOptionT,
    zhanDianBrandOption,
    ranLiaoOption,
    cardTypeOption,
    daoLuFenLei,
    daoLuFenLeiGd,
    vehicleCountMaskOption,
    mileageMaskOption,
    failedTypeOptionT,
    keyValueCardNum,
    isMoreThanSevenDaysAgo,
    failedKindOption,
    failedTypeOption,
    discountTypeOption,
    gridData,
    companyLabelOption,
    companyLabelOptionShow,
    stationType,
    oilConsumptionRangeOption,
    petrochemicalStopRadioOption,
}
